export const PayNowIcon = ({
  strokeColor = "var(--color-icon-bright)",
  ...props
}: any) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M14.6668 6.16699H1.3335C1.06016 6.16699 0.833496 5.94033 0.833496 5.66699C0.833496 5.39366 1.06016 5.16699 1.3335 5.16699H14.6668C14.9402 5.16699 15.1668 5.39366 15.1668 5.66699C15.1668 5.94033 14.9402 6.16699 14.6668 6.16699Z"
      fill={strokeColor}
    />
    <path
      d="M5.33333 11.5H4C3.72667 11.5 3.5 11.2733 3.5 11C3.5 10.7267 3.72667 10.5 4 10.5H5.33333C5.60667 10.5 5.83333 10.7267 5.83333 11C5.83333 11.2733 5.60667 11.5 5.33333 11.5Z"
      fill={strokeColor}
    />
    <path
      d="M9.66667 11.5H7C6.72667 11.5 6.5 11.2733 6.5 11C6.5 10.7267 6.72667 10.5 7 10.5H9.66667C9.94 10.5 10.1667 10.7267 10.1667 11C10.1667 11.2733 9.94 11.5 9.66667 11.5Z"
      fill={strokeColor}
    />
    <path
      d="M11.7068 14.1663H4.2935C1.64016 14.1663 0.833496 13.3663 0.833496 10.7397V5.25967C0.833496 2.63301 1.64016 1.83301 4.2935 1.83301H11.7002C14.3535 1.83301 15.1602 2.63301 15.1602 5.25967V10.733C15.1668 13.3663 14.3602 14.1663 11.7068 14.1663ZM4.2935 2.83301C2.20016 2.83301 1.8335 3.19301 1.8335 5.25967V10.733C1.8335 12.7997 2.20016 13.1597 4.2935 13.1597H11.7002C13.7935 13.1597 14.1602 12.7997 14.1602 10.733V5.25967C14.1602 3.19301 13.7935 2.83301 11.7002 2.83301H4.2935Z"
      fill={strokeColor}
    />
  </svg>
);
